export const AUTH_URL = Object.freeze({
  AUTHORIZE :`/session/login/authorize`,
  VERIFY:`/session/login/verify`,
  GENERATOR_TOKEN:`/session/login/token`,
  USER_VERIFY:`/users/verify`,
  PERMISSION_AUTHORIZE:`/roles/permissions/authorize`,
  LOGOUT:`/session/logout`,
  REFRESH_TOKEN:`/session/refresh/token`,
})